<template>
  <b-card
  >
      <b-button
          variant="primary"
          class="mb-1"
          @click="showModal"
      >
        جدید
      </b-button>
      <b-table
          bordered
          hover
          striped
          responsive
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          :busy="loading"
          :no-local-sorting="true"
          @sort-changed="sortChange"
      >
        <template #cell(Id)="data">
          <b-link
              :to="{ }"
              class="font-weight-bold"
          >
            #{{ data.value }}
          </b-link>
        </template>

        <template #cell(CreatedAt)="row">
          {{ row.value | date }}
        </template>

        <template #cell(ActivityGroup)="data">
          {{ data.value.Title }}
        </template>

        <template #cell(ActivityPackage)="data">
          {{ data.value.Title }}
        </template>

        <template #cell(ActivityPackageCourse)="data">
          {{ data.value.Title }}
        </template>

        <template #cell(Bank)="row">
          {{ enums('bank','value',row.value,'text') }}
        </template>

        <template #cell(IsPaid)="data">
          <b-badge
              v-if="data.item.IsPaid"
              variant="success"
          >
            پرداخت شده
          </b-badge>
          <b-badge
              v-else
              variant="warning"
              @click="showConfirmModal(data.item)"
          >
            پرداخت نشده
          </b-badge>
        </template>

        <template #cell(IsActive)="data">
          <b-avatar
              v-if="data.item.IsPaid"
              v-b-tooltip.hover :title="data.value ? 'فعال' : 'غیرفعال'"
              size="32"
              :variant="data.value ? 'light-success' : 'light-warning'">
            <feather-icon
                @click="toggleActivity(data.item)"
                :icon="data.value ? 'CheckCircleIcon':'XCircleIcon'"
                class="cursor-pointer"
            />
          </b-avatar>
        </template>

        <template #cell(Price)="data">
          {{ data.value | price }}
        </template>

        <template #cell(Coupon)="data">
          {{ data.value.Title }}
        </template>

        <template #table-busy>
          <div
              class="text-center my-2"
          >
            <b-spinner
                variant="primary"
                class="align-middle"
            />
            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
          </div>
        </template>
      </b-table>
      <z-pagination
          :per-page="5"
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="get"
      />
    <b-modal
        v-model="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تخصیص گروه ورزشی"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="add"
    >
      <b-form-group
          label="گروه ورزشی"
          label-for="ActivityGroupId"
      >
        <z-activity-group v-model="ActivityGroupId" :multiple="false" :clearable="false" />
      </b-form-group>
    </b-modal>

    <b-modal
        v-model="isShowConfirm"
        v-if="isShowConfirm"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        modal-class="confirm-pay-modal"
        title="تایید پرداخت"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="confirmPay"
    >
      <div>
        پرداخت مورد نظر تایید شود؟
      </div>
    </b-modal>
  </b-card>
</template>
<script>
import ZActivityPackage from '@/tools/activitypackage'
import ZActivityPackageCourse from '@/tools/activitypackagecourse'
import ZActivityGroup from "@/tools/activitygroup.vue";
export default {
  name: 'ActivityPackageOrder',
  components: {ZActivityGroup, ZActivityPackage,ZActivityPackageCourse },
  props: {
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      totalRows: null,
      isShowConfirm: false,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'ActivityGroup',
          label: 'گروه',
        },
        {
          key: 'ActivityPackage',
          label: 'برنامه',
        },
        {
          key: 'ActivityPackageCourse',
          label: 'دوره',
        },
        {
          key: 'Code',
          label: 'کد پیگیری',
          tdClass: 'col-width-15',
        },
        {
          key: 'Price',
          label: 'مبلغ',
          sortable: true,
        },
        {
          key: 'Coupon',
          label: 'تخفیف',
        },
        {
          key: 'Bank',
          label: 'بانک',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          sortable: true,
        },
        {
          key: 'IsPaid',
          label: 'پرداخت',
        },
        {
          key: 'IsActive',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 0,
      },
      filterOptions: {
        userId: this.userId,
        Page: 1,
        PerPage: 5,
        SortBy: null,
        IsDesc: true,
        Bank: [],
        ActivityPackageId: [],
        ActivityPackageCourseId: [],
        ActivityGroupId: null,
        CouponId: [],
      },
      isShow: false,
      ActivityGroupId: null,
    }
  },
  created() {
    this.get()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.get(1)
      }
    },
    get(pageNumber) {
      if (!this.$can('show', 'OrderView')) return
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$http.post(this.$api.activitypackageorder.getlist, this.filterOptions).then(res => {
        this.totalRows = res.totalRow
        this.items = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    add(){
      this.$http.post(
          this.$api.activitypackageorder.add, {
            Price: this.Price,
            UserId: this.userId,
            ActivityGroupId: this.ActivityGroupId
          },
      )
          .then(() => {
            this.get()
          })
    },
    toggleActivity(row){
      this.$http.post(this.$api.activitypackageorder.update, {
        Id: row.Id,
        IsActive: !row.IsActive
      }).then(() => {
        row.IsActive = !row.IsActive
      })
   },
    confirmPay(){
      this.isShowConfirm = false
      this.$http.post(
          this.$api.activitypackageorder.confirmpay, {
            Id: this.row.Id,
          },
      )
          .then(res => {
            this.get()
            this.$emit('UserDietTerms')
            this.$emit('UserDietOrder')
          })
    },
    showModal(){
      this.ActivityPackageId = null
      this.ActivityPackageCourseId = null
      this.IsActivityPackage = true
      this.isShow = true
    },
    showConfirmModal(row){
      this.row = row
      this.isShowConfirm = true
    }
  },
}
</script>

<style>
.tableActionCellWidth{
  width:500px;
}
</style>
